import {useEffect, useState} from 'react';
import {apiClient} from '../../../api/apiClient';
import {authHeaders} from '../../../api/apiClient';
import {token} from '../../../api/api';

export const VisitsSection = () => {
    const [stats, setStats] = useState<any>(null);
    const [visits, setVisits] = useState<any[]>([]);
    const [from, setFrom] = useState('');
    const [to, setTo] = useState('');

    const load = () => {
        const params = new URLSearchParams();
        if (from) params.append('from', from);
        if (to) params.append('to', to);
        const query = params.toString() ? `?${params}` : '';

        apiClient.get(`/visits/stats${query}`, authHeaders(token())).then((r: any) => setStats(r.data));
        apiClient.get(`/visits${query}`, authHeaders(token())).then((r: any) => setVisits(r.data));
    };

    useEffect(() => {
        load();
    }, []);

    const setPreset = (preset: 'today' | 'week' | 'month' | 'all') => {
        const now = new Date();
        const toStr = now.toISOString().split('T')[0];

        if (preset === 'today') {
            setFrom(toStr);
            setTo(toStr);
        } else if (preset === 'week') {
            const d = new Date(now);
            d.setDate(d.getDate() - 7);
            setFrom(d.toISOString().split('T')[0]);
            setTo(toStr);
        } else if (preset === 'month') {
            const d = new Date(now);
            d.setMonth(d.getMonth() - 1);
            setFrom(d.toISOString().split('T')[0]);
            setTo(toStr);
        } else {
            setFrom('');
            setTo('');
        }
    };

    useEffect(() => {
        load();
    }, [from, to]);

    return (
        <div>
            <div className="admin-card">
                <div>
                    <div>
                        <button className="btn-admin btn-admin-secondary"
                                onClick={() => setPreset('today')}>Aujourd'hui
                        </button>
                        <button className="btn-admin btn-admin-secondary" onClick={() => setPreset('week')}>7 jours
                        </button>
                        <button className="btn-admin btn-admin-secondary" onClick={() => setPreset('month')}>30 jours
                        </button>
                        <button className="btn-admin btn-admin-secondary" onClick={() => setPreset('all')}>Tout</button>
                    </div>
                </div>
            </div>

            {stats && (
                <div>
                    <div className="admin-card">
                        <div className="table-container">
                            <p>{stats.total}</p>
                            <p>Visites totales</p>
                        </div>
                    </div>
                    {stats.byCountry.map((c: any) => (
                        <div key={c.country} className="admin-card">
                            <div className="table-container">
                                <p>{c._count}</p>
                                <p>{c.country || 'Inconnu'}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {stats?.byPage && (
                <div className="admin-card">
                    <div className="table-container">
                        <p>Pages les plus visitées</p>
                        <table className="admin-table">
                            <thead>
                            <tr>
                                <th>Page</th>
                                <th>Visites</th>
                            </tr>
                            </thead>
                            <tbody>
                            {stats.byPage.map((p: any) => (
                                <tr key={p.page}>
                                    <td>{p.page}</td>
                                    <td>{p._count}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            <div className="admin-card">
                <p>Dernières visites {visits.length > 0 && `(${visits.length})`}</p>
                <div>
                    <div className="table-container">
                        <table className="admin-table">
                            <thead>
                            <tr>
                                <th>Date</th>
                                <th>Page</th>
                                <th>Pays</th>
                                <th>Ville</th>
                                <th>IP</th>
                            </tr>
                            </thead>
                            <tbody>
                            {visits.map((v: any) => (
                                <tr key={v.id}>
                                    <td>{new Date(v.createdAt).toLocaleString('fr-FR')}</td>
                                    <td>{v.page}</td>
                                    <td>{v.country || '—'}</td>
                                    <td>{v.city || '—'}</td>
                                    <td style={{fontSize: '0.8rem', color: '#8a7f72'}}>{v.ip}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
